import React, { useEffect, useState } from "react";
import {
  DataGrid,
  GridActionsCellItem,
} from "@mui/x-data-grid";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import { Edit, Delete, Add } from "@mui/icons-material";
import { getAllZonePincodes, saveZonePincode, updateZonePincode, deleteZonePincode } from '../service/zoneService';

const ZonePincodeManager = () => {
  const [rows, setRows] = useState([]);
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState({
    pincode: "",
    city: "",
    area: "",
    latitude: "",
    longitude: "",
    zoneId: "",
  });

  // Fetch all pincodes
  const fetchData = async () => {
    try {
      const res = await getAllZonePincodes();
      setRows(res.data);
    } catch (err) {
      console.error("Error fetching pincodes", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleOpen = (row) => {
    if (row) {
      setEditing(row);
      setForm(row);
    } else {
      setEditing(null);
      setForm({
        pincode: "",
        city: "",
        area: "",
        latitude: "",
        longitude: "",
        zoneId: "",
      });
    }
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setEditing(null);
  };

  const handleSave = async () => {
    try {
      if (editing && editing.id) {
        await updateZonePincode(editing.id, form);
      } else {
        await saveZonePincode(form); //axiosInstance.post("/zone-pincodes", form);
      }
      handleClose();
      fetchData();
    } catch (err) {
      console.error("Error saving pincode", err);
    }
  };

  const handleDelete = async (id) => {
    if (!id) return;
    try {
      await deleteZonePincode(id); // axiosInstance.delete(`/zone-pincodes/${id}`);
      fetchData();
    } catch (err) {
      console.error("Error deleting pincode", err);
    }
  };

  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "pincode", headerName: "Pincode", flex: 1 },
    { field: "city", headerName: "City", flex: 1 },
    { field: "area", headerName: "Area", flex: 1 },
    { field: "latitude", headerName: "Latitude", flex: 1 },
    { field: "longitude", headerName: "Longitude", flex: 1 },
    { field: "zoneId", headerName: "Zone ID", flex: 1 },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 120,
      getActions: (params) => [
        <GridActionsCellItem
          icon={<Edit />}
          label="Edit"
          onClick={() => handleOpen(params.row)}
        />,
        <GridActionsCellItem
          icon={<Delete />}
          label="Delete"
          onClick={() => handleDelete(params.row.id)}
        />,
      ],
    },
  ];

  return (
    <div style={{ height: 600, width: "100%" }}>
      <Button
        startIcon={<Add />}
        variant="contained"
        style={{ marginBottom: "16px" }}
        onClick={() => handleOpen()}
      >
        Add ZonePincode
      </Button>

      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={10}
        getRowId={(row) => row.id}
      />

      {/* Dialog Form */}
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          {editing ? "Edit ZonePincode" : "Add ZonePincode"}
        </DialogTitle>
        <DialogContent style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          <TextField
            label="Pincode"
            value={form.pincode || ""}
            onChange={(e) => setForm({ ...form, pincode: e.target.value })}
          />
          <TextField
            label="City"
            value={form.city || ""}
            onChange={(e) => setForm({ ...form, city: e.target.value })}
          />
          <TextField
            label="Area"
            value={form.area || ""}
            onChange={(e) => setForm({ ...form, area: e.target.value })}
          />
          <TextField
            label="Latitude"
            type="number"
            value={form.latitude || ""}
            onChange={(e) => setForm({ ...form, latitude: e.target.value })}
          />
          <TextField
            label="Longitude"
            type="number"
            value={form.longitude || ""}
            onChange={(e) => setForm({ ...form, longitude: e.target.value })}
          />
          <TextField
            label="Zone ID"
            type="number"
            value={form.zoneId || ""}
            onChange={(e) => setForm({ ...form, zoneId: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button variant="contained" onClick={handleSave}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ZonePincodeManager;
